import React from "react";
import styled from "styled-components";
import InlineSVG from "svg-inline-react";
import { Marquee } from "../ui/animations";

const SVGWrapper = styled.div`
  width: 80vw;
  position: relative;
  svg {
    position: absolute;
    animation: ${Marquee} 33.75s linear infinite;
  }
`;

const SVGMarquee = props => {
  return (
    <SVGWrapper>
      <InlineSVG src={props.src} />
    </SVGWrapper>
  );
};

export default SVGMarquee;
